export function loadPopupWindowCompletion(data, client) {
  return {
    type: 'LOAD_POPUP_WINDOW_COMPLETION',
    data,
    client,
  }
}

export function loadPayNoticeCompletion(data, client) {
  return {
    type: 'LOAD_PAY_NOTICE_COMPLETION',
    data,
    client,
  }
}

export function readPopupContent(popupId) {
  return {
    type: 'READ_POPUP_CONTENT',
    popupId,
  }
}

export function readPopupContentCompletion(error, data) {
  return {
    type: 'READ_POPUP_CONTENT_COMPELTION',
    error,
    data,
  }
}

export function readPayNoticeContent(popupId) {
  return {
    type: 'READ_PAY_NOTICE_CONTENT',
    popupId,
  }
}

export function readPayNoticeContentCompletion(error, data) {
  return {
    type: 'READ_PAY_NOTICE_CONTENT_COMPELTION',
    error,
    data,
  }
}

export function shiftPopupWindow() {
  return {
    type: 'SHIFT_POPUP_WINDOW',
  };
}

export function shiftPayNotice() {
  return {
    type: 'SHIFT_PAY_NOTICE',
  };
}
